import { Component, ReactNode } from 'react';

import { LoggerHelper } from '@helpers';

export interface ErrorBoundaryProps {
	fallback: ReactNode;
	children: ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: Error) {
		LoggerHelper.error('App', 'ErrorBoundary:', { error }, { overlay: { show: true } });

		return { hasError: true };
	}

	render() {
		const { children, fallback } = this.props;

		if (this.state.hasError) {
			return fallback;
		}

		return children;
	}
}
